import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import LocalStorageService from '@application/common/local-storage-service';
import { vdkEmHappinessPortalApi } from '@infrastructure/vdk-em-happiness-portal-api';
import { useNotificationsHub } from '@ui/hooks/useNotificationsHub';
import { setBadgeCount, setBootstrap } from '@application/features/notifications/notificationsSlice';
import { initializeNotificationAsync } from '@application/features/notifications/notificationsThunks';
// Headless component that connects to the notifications hub when user is logged in
// and maintains a badge count in the Redux store.
const NotificationsInitializer = () => {
    const dispatch = useAppDispatch();
    const currentUser = useAppSelector((s) => s.auth.currentUser);
    const selectedCompanyId = useAppSelector((s) => s.company.selectedCompanyId);
    const apiBase = (vdkEmHappinessPortalApi.defaults?.baseURL || '').replace(/\/+$/, '');
    const getToken = () => LocalStorageService.getMSAccessToken() || '';
    const isAuthenticated = !!currentUser &&
        !!LocalStorageService.getMSAccessToken() &&
        !!LocalStorageService.getAccessToken();
    const { bootstrap, unreadCount, setHandlers } = useNotificationsHub(apiBase, getToken, isAuthenticated);
    // Compute initial total from bootstrap
    useEffect(() => {
        if (!bootstrap)
            return;
        dispatch(setBootstrap(bootstrap));
        dispatch(setBadgeCount(bootstrap.unreadCount ?? 0));
    }, [bootstrap, dispatch]);
    // Keep badge in sync with server-pushed unread count
    useEffect(() => {
        // unreadCount is provided by hub "unreadCountUpdated" event
        if (!isAuthenticated)
            return;
        dispatch(setBadgeCount(unreadCount || 0));
    }, [unreadCount, isAuthenticated, dispatch]);
    // Keep the list in sync when the server pushes an update. Dispatched through the shared
    // notifications thunk (goes via the API client, which attaches PayloadCompanyId) so the
    // bell stays scoped to the currently selected company/region on every refresh.
    useEffect(() => {
        if (!isAuthenticated)
            return;
        setHandlers({
            onNotificationsUpdated: () => {
                dispatch(initializeNotificationAsync());
            }
        });
    }, [isAuthenticated, setHandlers, dispatch]);
    // Re-scope the list whenever the sidebar's company/region selection changes
    useEffect(() => {
        if (!isAuthenticated)
            return;
        dispatch(initializeNotificationAsync());
    }, [selectedCompanyId, isAuthenticated, dispatch]);
    return null;
};
export default NotificationsInitializer;
